<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :content="page.content" />

		<section class="promotions main-content rooms background-light">
			<!-- <filter-buttons :items="types" :filter="filter" @change-filter="filter = $event" /> -->
			<packages :items="packagesData" :filter="filter" @change-filter="filter = $event" />
		</section>

		<contentblocks :items="page.contentblocks" />
		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:items="page.frequentlyAskedQuestion.faqitems"
			:header="page.frequentlyAskedQuestion.header"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const filter = ref('showAll');

const { data: packagesData } = await useWebsiteFetch('meetingpackages', {
	query: { language: locale.value },
	key: `${locale.value}/meetingpackages`,
});

// const types = [...new Set(packagesData.value.map(({ category }) => category))];
</script>
